import { Container, Loader, Stack } from '@qred/components-library';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FlowTypes } from '~/enums';
import { areSameCompanies } from '~/helpers/utils';
import { setCompanyIsNew } from '~/store/slices/onboardingApplication.slice';
import { ApiStatus, RootState } from '~/store/types/sharedTypes';
import { CompanySearchGermany } from './components/CompanySearchGermany';

export const CompanySelectorGermany = () => {
  const dispatch = useDispatch();

  const {
    form,
    apiStatus,
    overview,
    companyIsNew,
    flowType,
    userId,
  } = useSelector((state: RootState) => state.onboardingApplication);

  useEffect(() => {
    const isAuthenticatedNlc =
      flowType === FlowTypes.Authenticated &&
      (form.organizationNumber || form.connectId) &&
      apiStatus.clients === ApiStatus.Completed &&
      !overview.clients.some((client) =>
        areSameCompanies(
          client.company_no || client.connect_id,
          form.organizationNumber || form.connectId
        )
      );

    if (flowType === FlowTypes.Manual || !userId || isAuthenticatedNlc) {
      dispatch(setCompanyIsNew(true));
    }
  }, []);

  return (
    <Container w="100%" style={{ flexGrow: 1 }}>
      {apiStatus.clients !== ApiStatus.Started ? (
        // todo: handle FlowTypes.Authenticated

        <Stack spacing="xxl" mt="md" h="100%">
          {companyIsNew && <CompanySearchGermany />}
        </Stack>
      ) : (
        <Loader />
      )}
    </Container>
  );
};
